var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useBreakpoint } from '@airtel/air-design-system';
import { useEffect, useState } from 'react';
import { withBoundaries } from '../../hoc';
import { clearFilter, updateFilterItem } from './FilterUtils';
import { FilterDesktop } from './components/filter-desktop';
import { FilterMobile } from './components/filter-mobile';
var FilterWidgetComponent = props => {
  var _a;
  var id = props.id,
    filterData = props.filterData,
    type = props.type,
    onUserAction = props.onUserAction,
    onClearPress = props.onClearPress,
    onCheckPress = props.onCheckPress,
    onApplyFilterPress = props.onApplyFilterPress,
    onCloseFilterPress = props.onCloseFilterPress,
    restProps = __rest(props, ["id", "filterData", "type", "onUserAction", "onClearPress", "onCheckPress", "onApplyFilterPress", "onCloseFilterPress"]);
  var _useState = useState(filterData),
    filters = _useState[0],
    setFilters = _useState[1];
  var _useState2 = useState((_a = filterData === null || filterData === void 0 ? void 0 : filterData[0]) === null || _a === void 0 ? void 0 : _a.filterItemValue),
    selectedFilter = _useState2[0],
    setSelectedFilter = _useState2[1];
  var _useBreakpoint = useBreakpoint({
      returnAsObject: true
    }),
    isLargeScreen = _useBreakpoint.isLargeScreen;
  useEffect(() => {
    var _a;
    setFilters(filterData);
    setSelectedFilter((_a = filterData === null || filterData === void 0 ? void 0 : filterData[0]) === null || _a === void 0 ? void 0 : _a.filterItemValue);
  }, [filterData]);
  var onClear = () => {
    var clearedFilter = clearFilter(filters);
    setFilters(clearedFilter);
    onClearPress && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
      id
    }, onClearPress), {
      filterList: clearedFilter
    }));
  };
  var onCheck = selectedFilter => {
    var updatedFilter = filters === null || filters === void 0 ? void 0 : filters.map(filterItem => {
      var filter = updateFilterItem(filterItem === null || filterItem === void 0 ? void 0 : filterItem.filterItemValue, selectedFilter, type);
      return Object.assign(Object.assign({}, filterItem), {
        filterItemValue: filter
      });
    });
    setFilters(updatedFilter);
    onCheckPress && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
      id
    }, onCheckPress), {
      selectedFilter,
      filterList: updatedFilter
    }));
  };
  var onSelectedFilterCategory = (_selectedSelection, selectedSelectionIndex) => {
    var updatedFilter = filters === null || filters === void 0 ? void 0 : filters.map((filterItem, filterItemIndex) => {
      filterItem.checked = selectedSelectionIndex === filterItemIndex;
      return filterItem;
    });
    setSelectedFilter(_selectedSelection === null || _selectedSelection === void 0 ? void 0 : _selectedSelection.filterItemValue);
    setFilters(updatedFilter);
  };
  var onSelectedFilter = _selectedFilter => {
    var updatedSelectedFilter = updateFilterItem(selectedFilter, _selectedFilter, type);
    setSelectedFilter(updatedSelectedFilter);
  };
  var onApplyFilter = () => {
    onApplyFilterPress && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
      id
    }, onApplyFilterPress), {
      filterList: filters
    }));
  };
  var onCloseFilter = () => {
    onCloseFilterPress && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
      id
    }, onCloseFilterPress), {
      filterList: {}
    }));
  };
  return _jsx(_Fragment, {
    children: isLargeScreen ? _jsx(FilterDesktop, Object.assign({
      filterData: filters,
      onClear: onClear,
      onCheck: onCheck,
      type: type
    }, restProps)) : _jsx(FilterMobile, Object.assign({
      filterData: filters,
      type: type,
      selectedFilter: selectedFilter,
      onClear: onClear,
      onSelectedFilterCategory: onSelectedFilterCategory,
      onSelectedFilter: onSelectedFilter,
      onApplyFilter: onApplyFilter,
      onCloseFilter: onCloseFilter
    }, restProps))
  });
};
export var FilterWidget = withBoundaries(FilterWidgetComponent);
FilterWidget.genericRendererKey = 'AirFilterSectionWidget';